/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CalculateSaasSubscriptionActualChargeRequest,
    CalculateSaasSubscriptionActualChargeResponse,
    CountResponse,
    CreateSubscriptionRequest,
    CreateSubscriptionResponse,
    GetCommentChatSubscriptionInfoResponse,
    GetMyEarningsResponse,
    GetMySubscriptionDetailsResponse,
    GetSellerUpgradableSubscriptionPlanResponse,
    GetSubscriptionPaymentMethodsResponse,
    GetSubscriptionPlansResponse,
    GetSubscriptionTaxRequest,
    GetSubscriptionTaxResponse,
    UpdateSubscriptionRequest,
} from '../models';

export interface SellerSubscriptionApiControllerCalculateSaasSubscriptionActualChargeRequest {
    sellerId: string;
    subscriptionId: string;
    calculateSaasSubscriptionActualChargeRequest: CalculateSaasSubscriptionActualChargeRequest;
}

export interface SellerSubscriptionApiControllerCalculateSubscriptionTaxRequest {
    getSubscriptionTaxRequest: GetSubscriptionTaxRequest;
}

export interface SellerSubscriptionApiControllerCancelSubscriptionRequest {
    subscriptionId: string;
}

export interface SellerSubscriptionApiControllerCreateSubscriptionRequest {
    createSubscriptionRequest: CreateSubscriptionRequest;
    xPopPlatform?: SellerSubscriptionApiControllerCreateSubscriptionXPopPlatformEnum;
}

export interface SellerSubscriptionApiControllerGetCommentChatContactCountRequest {
    storeId: string;
}

export interface SellerSubscriptionApiControllerGetCommentChatSubscriptionInfoRequest {
    storeId: string;
}

export interface SellerSubscriptionApiControllerGetMyEarningsRequest {
    sellerId: string;
}

export interface SellerSubscriptionApiControllerGetSellerUpgradableSubscriptionPlanRequest {
    storeId: string;
}

export interface SellerSubscriptionApiControllerGetSubscriptionPaymentMethodsRequest {
    userId: string;
}

export interface SellerSubscriptionApiControllerUpdateSubscriptionPlansRequest {
    sellerId: string;
    subscriptionId: string;
    updateSubscriptionRequest: UpdateSubscriptionRequest;
    xPopPlatform?: SellerSubscriptionApiControllerUpdateSubscriptionPlansXPopPlatformEnum;
}

/**
 * 
 */
export class SellerSubscriptionApi extends runtime.BaseAPI {

    /**
     */
    async sellerSubscriptionApiControllerCalculateSaasSubscriptionActualChargeRaw(requestParameters: SellerSubscriptionApiControllerCalculateSaasSubscriptionActualChargeRequest): Promise<runtime.ApiResponse<CalculateSaasSubscriptionActualChargeResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling sellerSubscriptionApiControllerCalculateSaasSubscriptionActualCharge.');
        }

        if (requestParameters.subscriptionId === null || requestParameters.subscriptionId === undefined) {
            throw new runtime.RequiredError('subscriptionId','Required parameter requestParameters.subscriptionId was null or undefined when calling sellerSubscriptionApiControllerCalculateSaasSubscriptionActualCharge.');
        }

        if (requestParameters.calculateSaasSubscriptionActualChargeRequest === null || requestParameters.calculateSaasSubscriptionActualChargeRequest === undefined) {
            throw new runtime.RequiredError('calculateSaasSubscriptionActualChargeRequest','Required parameter requestParameters.calculateSaasSubscriptionActualChargeRequest was null or undefined when calling sellerSubscriptionApiControllerCalculateSaasSubscriptionActualCharge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/subscriptions/{subscriptionId}:calculate-charge`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters.subscriptionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.calculateSaasSubscriptionActualChargeRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerCalculateSaasSubscriptionActualCharge(requestParameters: SellerSubscriptionApiControllerCalculateSaasSubscriptionActualChargeRequest): Promise<CalculateSaasSubscriptionActualChargeResponse> {
        const response = await this.sellerSubscriptionApiControllerCalculateSaasSubscriptionActualChargeRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async sellerSubscriptionApiControllerCalculateSubscriptionTaxRaw(requestParameters: SellerSubscriptionApiControllerCalculateSubscriptionTaxRequest): Promise<runtime.ApiResponse<GetSubscriptionTaxResponse>> {
        if (requestParameters.getSubscriptionTaxRequest === null || requestParameters.getSubscriptionTaxRequest === undefined) {
            throw new runtime.RequiredError('getSubscriptionTaxRequest','Required parameter requestParameters.getSubscriptionTaxRequest was null or undefined when calling sellerSubscriptionApiControllerCalculateSubscriptionTax.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/subscription-tax`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.getSubscriptionTaxRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerCalculateSubscriptionTax(requestParameters: SellerSubscriptionApiControllerCalculateSubscriptionTaxRequest): Promise<GetSubscriptionTaxResponse> {
        const response = await this.sellerSubscriptionApiControllerCalculateSubscriptionTaxRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async sellerSubscriptionApiControllerCancelSubscriptionRaw(requestParameters: SellerSubscriptionApiControllerCancelSubscriptionRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.subscriptionId === null || requestParameters.subscriptionId === undefined) {
            throw new runtime.RequiredError('subscriptionId','Required parameter requestParameters.subscriptionId was null or undefined when calling sellerSubscriptionApiControllerCancelSubscription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/seller-subscriptions/{subscriptionId}:cancel`.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters.subscriptionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerCancelSubscription(requestParameters: SellerSubscriptionApiControllerCancelSubscriptionRequest): Promise<void> {
        await this.sellerSubscriptionApiControllerCancelSubscriptionRaw(requestParameters);
    }

    /**
     */
    async sellerSubscriptionApiControllerCreateSubscriptionRaw(requestParameters: SellerSubscriptionApiControllerCreateSubscriptionRequest): Promise<runtime.ApiResponse<CreateSubscriptionResponse>> {
        if (requestParameters.createSubscriptionRequest === null || requestParameters.createSubscriptionRequest === undefined) {
            throw new runtime.RequiredError('createSubscriptionRequest','Required parameter requestParameters.createSubscriptionRequest was null or undefined when calling sellerSubscriptionApiControllerCreateSubscription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xPopPlatform !== undefined && requestParameters.xPopPlatform !== null) {
            headerParameters['x-pop-platform'] = String(requestParameters.xPopPlatform);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/seller-subscriptions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createSubscriptionRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerCreateSubscription(requestParameters: SellerSubscriptionApiControllerCreateSubscriptionRequest): Promise<CreateSubscriptionResponse> {
        const response = await this.sellerSubscriptionApiControllerCreateSubscriptionRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async sellerSubscriptionApiControllerGetCommentChatContactCountRaw(requestParameters: SellerSubscriptionApiControllerGetCommentChatContactCountRequest): Promise<runtime.ApiResponse<CountResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling sellerSubscriptionApiControllerGetCommentChatContactCount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:getCommentChatContactCount`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerGetCommentChatContactCount(requestParameters: SellerSubscriptionApiControllerGetCommentChatContactCountRequest): Promise<CountResponse> {
        const response = await this.sellerSubscriptionApiControllerGetCommentChatContactCountRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async sellerSubscriptionApiControllerGetCommentChatSubscriptionInfoRaw(requestParameters: SellerSubscriptionApiControllerGetCommentChatSubscriptionInfoRequest): Promise<runtime.ApiResponse<GetCommentChatSubscriptionInfoResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling sellerSubscriptionApiControllerGetCommentChatSubscriptionInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/comment-chat-subscription-info`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerGetCommentChatSubscriptionInfo(requestParameters: SellerSubscriptionApiControllerGetCommentChatSubscriptionInfoRequest): Promise<GetCommentChatSubscriptionInfoResponse> {
        const response = await this.sellerSubscriptionApiControllerGetCommentChatSubscriptionInfoRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async sellerSubscriptionApiControllerGetMyEarningsRaw(requestParameters: SellerSubscriptionApiControllerGetMyEarningsRequest): Promise<runtime.ApiResponse<GetMyEarningsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling sellerSubscriptionApiControllerGetMyEarnings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/my-earnings-info`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerGetMyEarnings(requestParameters: SellerSubscriptionApiControllerGetMyEarningsRequest): Promise<GetMyEarningsResponse> {
        const response = await this.sellerSubscriptionApiControllerGetMyEarningsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async sellerSubscriptionApiControllerGetSellerUpgradableSubscriptionPlanRaw(requestParameters: SellerSubscriptionApiControllerGetSellerUpgradableSubscriptionPlanRequest): Promise<runtime.ApiResponse<GetSellerUpgradableSubscriptionPlanResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling sellerSubscriptionApiControllerGetSellerUpgradableSubscriptionPlan.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/upgradable-subscription-plans`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerGetSellerUpgradableSubscriptionPlan(requestParameters: SellerSubscriptionApiControllerGetSellerUpgradableSubscriptionPlanRequest): Promise<GetSellerUpgradableSubscriptionPlanResponse> {
        const response = await this.sellerSubscriptionApiControllerGetSellerUpgradableSubscriptionPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async sellerSubscriptionApiControllerGetSubscriptionRaw(): Promise<runtime.ApiResponse<GetMySubscriptionDetailsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/seller-subscription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerGetSubscription(): Promise<GetMySubscriptionDetailsResponse> {
        const response = await this.sellerSubscriptionApiControllerGetSubscriptionRaw();
        return await response.value();
    }

    /**
     */
    async sellerSubscriptionApiControllerGetSubscriptionPaymentMethodsRaw(requestParameters: SellerSubscriptionApiControllerGetSubscriptionPaymentMethodsRequest): Promise<runtime.ApiResponse<GetSubscriptionPaymentMethodsResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling sellerSubscriptionApiControllerGetSubscriptionPaymentMethods.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/subscription-payment-methods`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerGetSubscriptionPaymentMethods(requestParameters: SellerSubscriptionApiControllerGetSubscriptionPaymentMethodsRequest): Promise<GetSubscriptionPaymentMethodsResponse> {
        const response = await this.sellerSubscriptionApiControllerGetSubscriptionPaymentMethodsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async sellerSubscriptionApiControllerGetSubscriptionPlansRaw(): Promise<runtime.ApiResponse<GetSubscriptionPlansResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/seller-subscription-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerGetSubscriptionPlans(): Promise<GetSubscriptionPlansResponse> {
        const response = await this.sellerSubscriptionApiControllerGetSubscriptionPlansRaw();
        return await response.value();
    }

    /**
     */
    async sellerSubscriptionApiControllerUpdateSubscriptionPlansRaw(requestParameters: SellerSubscriptionApiControllerUpdateSubscriptionPlansRequest): Promise<runtime.ApiResponse<CreateSubscriptionResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling sellerSubscriptionApiControllerUpdateSubscriptionPlans.');
        }

        if (requestParameters.subscriptionId === null || requestParameters.subscriptionId === undefined) {
            throw new runtime.RequiredError('subscriptionId','Required parameter requestParameters.subscriptionId was null or undefined when calling sellerSubscriptionApiControllerUpdateSubscriptionPlans.');
        }

        if (requestParameters.updateSubscriptionRequest === null || requestParameters.updateSubscriptionRequest === undefined) {
            throw new runtime.RequiredError('updateSubscriptionRequest','Required parameter requestParameters.updateSubscriptionRequest was null or undefined when calling sellerSubscriptionApiControllerUpdateSubscriptionPlans.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xPopPlatform !== undefined && requestParameters.xPopPlatform !== null) {
            headerParameters['x-pop-platform'] = String(requestParameters.xPopPlatform);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/subscriptions/{subscriptionId}:update`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters.subscriptionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateSubscriptionRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async sellerSubscriptionApiControllerUpdateSubscriptionPlans(requestParameters: SellerSubscriptionApiControllerUpdateSubscriptionPlansRequest): Promise<CreateSubscriptionResponse> {
        const response = await this.sellerSubscriptionApiControllerUpdateSubscriptionPlansRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum SellerSubscriptionApiControllerCreateSubscriptionXPopPlatformEnum {
    Psl = 'psl',
    Popstore = 'popstore'
}
/**
    * @export
    * @enum {string}
    */
export enum SellerSubscriptionApiControllerUpdateSubscriptionPlansXPopPlatformEnum {
    Psl = 'psl',
    Popstore = 'popstore'
}
